export default "__VITE_ASSET__CMRlVcXT__"